<template>
    <section class="marketing-overview">
        <title-date-component :titleOption="titleOption"></title-date-component>
        <section class="data-box">
            <LineTipsComponent style="width:20%; margin-top:33px;" :lineTipsInfo="lineTipsInfo"></LineTipsComponent>
            <columnar-component style="width:75%;" :columnarData="columnarData"></columnar-component>
        </section>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .marketing-overview {
        height: 100%;
        overflow: hidden;
        .title-date {
            margin-top: 10px;
            padding: 0 20px;
        }
        .data-box {
            width: 100%;
            height: 255px;
            padding-left: 40px;
            margin-top: 25px;
        }
    }
</style>

<script>
    import TitleDateComponent from '../../../../components/title-date/TitleDate.vue'
    import LineTipsComponent from '../../../../operateData/components/line-tips/LineTips.vue'
    import ColumnarComponent from '../../../../components/echarts/Columnar.vue'

    export default {
        components: {
            TitleDateComponent,
            LineTipsComponent,
            ColumnarComponent
        },
        data () {
            return {
                titleOption: {
                    title: '商品分析',
                    more: true,
                    moreUrl: 'menpiaoProductData'
                }
            }
        },
        props: ['resultData'],
        computed: {
            // 动销率指标
            lineTipsInfo () {
                return {
                    name: '动销率',
                    value: this.resultData.saleProductRate,
                    unit: '%',
                    compare: this.resultData.saleProductRatePercent,
                    title: '有销量的在线商品数/在线商品数',
                    compareInfo: this.resultData.compareInfo
                }
            },

            // 图表数据
            columnarData () {
                return [
                    this.resultData.payProductNum,
                    this.resultData.orderProductNum,
                    this.resultData.visitProductNum,
                    this.resultData.onlineProductNum
                ]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ProductAnalysis.vue?56c19d30